import { isAppHost, isInstalledApp, isTwa } from '../marketing/utils/isInstalledApp';
import { isSearchCrawler } from './searchCrawler';

export function shouldRegisterPushWorker(): boolean {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return false;
  if (isSearchCrawler()) return false;
  if (isTwa()) return false;

  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return isAppHost() || isInstalledApp();
}

function sendConfigToSW(sw: ServiceWorker, sent: Set<ServiceWorker>): void {
  if (sent.has(sw)) return;

  const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

  if (!config.apiKey || !config.projectId) return;

  sent.add(sw);
  window.setTimeout(() => {
    try {
      sw.postMessage({ type: 'FIREBASE_CONFIG', config });
    } catch {
      sent.delete(sw);
    }
  }, 500);
}

export function registerPushServiceWorker(): void {
  if (!shouldRegisterPushWorker()) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        if (registration.scope.includes('firebase-cloud-messaging-push-scope')) {
          registration.unregister();
        }
      });
    });

    navigator.serviceWorker
      .register('/firebase-messaging-sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        const sent = new Set<ServiceWorker>();
        if (registration.active) sendConfigToSW(registration.active, sent);
        if (registration.waiting) sendConfigToSW(registration.waiting, sent);

        registration.addEventListener('updatefound', () => {
          const next = registration.installing;
          if (!next) return;
          next.addEventListener('statechange', () => {
            if (next.state === 'installed' || next.state === 'activating') {
              sendConfigToSW(next, sent);
            }
          });
        });
      })
      .catch(() => {
        // Googlebot and some browsers reject SW registration. Push is optional.
      });
  });
}
